import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  private networkStatus = new BehaviorSubject<boolean>(navigator.onLine);
  isOnline$ = this.networkStatus.asObservable();

  constructor() {
    window.addEventListener('online', () => this.updateStatus(true));
    window.addEventListener('offline', () => this.updateStatus(false));
  }

  private updateStatus(status: boolean) {
    this.networkStatus.next(status);
  }

  get currentStatus() {
    return this.networkStatus.value;
  }
}
